import React, { useEffect } from 'react'
import {appApi} from '../../services';
import {LeftPanel} from '../common/templates/Login';
import { handleAppError } from '../handlers';
import { loginPaths } from '../../constants/roleDetails';
import { withRouter } from 'react-router-dom';
import { queryParams } from '../../utils';

const SamlLoginPage = ({history, getLoginStatus}) => {

  const handleLogin = async () => {
      const searchString = window.location.search
      const saml_response_id = queryParams(searchString).id

      let cal_http_https = window.API_URL.search('https') === -1 ? 'http' : 'https';
      let api_url = window.API_URL;
      let cal_url = api_url.replace('/v1/', '');

      const options = { data: {id : saml_response_id} }
      
      try {
        const response = await appApi.samlLogin(options);

        if(response.headers['x-ekincare-key']) {
            getLoginStatus(true);
            window.axios.defaults.headers.common['X-EKINCARE-KEY'] = response.headers['x-ekincare-key'];
            window.axios.defaults.headers.common['X-COMPANY-ID'] = response.data.company_id;
            sessionStorage.setItem('axiosHeaders', response.headers['x-ekincare-key']);
            sessionStorage.setItem('showPreEmp', response.data.enable_pre_emp);
            sessionStorage.setItem('hr_name', response.data.staff.name);
            function setRoleInSessionStorage(role) {
              sessionStorage.setItem('role', role);
              window.dispatchEvent(new Event('roleSet'));
            }
            setRoleInSessionStorage(response.data.role);
            sessionStorage.setItem('companies', JSON.stringify(response.data.companies?.filter(e => e.id !== undefined && e.id !== null)));
            sessionStorage.setItem('company_id', response.data.company_id);
            sessionStorage.setItem('logged_in_company_id', response.data.company_id)
            sessionStorage.setItem('company_name', response.data.staff.company_name);
            sessionStorage.setItem('is_child_company', JSON.stringify(response.data.parent_company_id));
            sessionStorage.setItem('hr_email', response.data.staff.email);
            sessionStorage.setItem('launch_date', response.data.launch_date);
            sessionStorage.setItem('is_active', response.data.is_active);
            sessionStorage.setItem(
              'calendar_url',
              cal_url.replace(cal_http_https, 'webcal') + '/calendar/' + response.data.calendar_token + '/calendar.ics'
            );
            let role = sessionStorage.getItem('role');
            if(response.data.is_active === 'inactive' && role === 'staff'){
              history.push('/mailer')
            }
            else{
              let sessionRole = sessionStorage.getItem('role')
              role = sessionRole ? sessionRole.toLowerCase().replace(/ /g, '_') : '/'
              history.push(loginPaths[role])
            }
        }
      } catch(error) {
        handleAppError(error)     
      }
    }

  useEffect(() => {
    handleLogin()
  }, [])

    return (
      <div className='text-center mt-8'>Please wait a moment...</div>
    )
}

export default withRouter(SamlLoginPage);
